import axios from 'api/axios-configure'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { TableReport } from 'components/TableReport'
import format from 'date-fns/format'
import { Icon, Tooltip } from 'monday-ui-react-core'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Row } from 'react-bootstrap'
import { GraphUp, CardList, CircleFill } from 'react-bootstrap-icons'
import { useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { StatementContext } from 'utils/context/StatementsContext'
import { Usertype } from '../../utils/Constants'
import { getRowSelectionBaseKey } from 'utils/commonUtils'
import pdfIcon from './../../assest/images/pdf-icon.svg'
import { PayoutAllStatementAdvanceSearchForm } from './PayoutAllStatementAdvanceSearchForm'
import './PayoutAllStatements.scss'
import PayoutAllStatementsForm from './PayoutAllStatementsForm'
import ReceiverList from '../ReceiverList/ReceiverList'
import { AuthSessionContext } from 'api/AuthSession'
import useRoles from 'hooks/useRoles'
import { DocumentTypes } from '../../utils/Constants'
import { useLocation } from 'react-router-dom';

const PayoutAllStatements = ({
    type,
    selectedStatementType,
    setSelectedStatementType,
    setAnalysisPayoutFilters,
}) => {
    const location = useLocation();
    const stateData = location.state?.runData;
    const { hasAnalysisReportAccess } = useRoles(type, 'PO')
    const { getPayoutStatementPDF } = useContext(StatementContext)
    const { IS_USER } = useContext(AuthSessionContext)
    const [searchParams] = useSearchParams()
    const [tableData, setTableData] = useState([])
    const [hasMassDownload, setHasMassDownload] = useState(type === Usertype.SENDER)
    const [selectedStatementDates, setSelectedStatementDates] = useState([null, null])
    const [selectedReportingMonthDates, setSelectedReportingMonthDates] = useState([null, null])
    const [selectedStatus, setSelectedStatus] = useState({
        value: 1,
    })
    const [searchInput, setSearchInput] = useState('')
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false)
    const [senderName, setSenderName] = useState('')
    const [propertyNumber, setPropertyNumber] = useState('')
    const [payoutId, setPayoutId] = useState('')
    const [propertyName, setPropertyName] = useState('')
    const [ownerNumber, setOwnerNumber] = useState('')
    const [ownerName, setOwnerName] = useState('')
    const [payoutName, setPayoutName] = useState('')
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 25, //customize the default page size
    })
    const [rowCount, setRowCount] = useState(0)
    const [sorting, setSorting] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isFetching, setIsFetching] = useState(false)
    const [rowSelection, setRowSelection] = useState({})
    const [openModal, setOpenModal] = useState(false)
    const [docSysNumber, setDocSysNumber] = useState('')
    const isUnreadFiltered = useRef(false)
    const [runNameOptions, setRunNameOptions] = useState([])
    const [runNames, setRunNames] = useState([])

    const isMounted = useRef(false)
    const [columnVisibility, setColumnVisibility] = useState({
        createdDate: false,
        statementType: false,
        runName: type === Usertype.SENDER ? false : true,        
        senderName: type === Usertype.SENDER ? false : true,
        ownerName1: type === Usertype.SENDER ? false : true,
    })
    
    //need to put this into a seperate component, but for time going to duplicate it in both PO and PB
    const requestAvailableRuns = (companyNumber, product) => {
        axios
        .get(
            'GetAvailableRuns',
            {
                params: {
                    companyNumber: companyNumber,
                    product: product
                }
            }
        )
        .then((response) => {
            return setRunNameOptions(response.data);
        })
        .catch(() => {
            return '';
        })
    }

    const senderColumns = useMemo(
        () => [
            {
                header: 'Actions',
                size: 60,
                maxSize: 60,
                enableSorting: false,
                Cell: ({ row }) => {
                    return (
                        <div className="d-flex align-items-center">
                            <Tooltip content="Download PDF">
                                <Icon
                                    iconSize={24}
                                    iconType={Icon.type.SRC}
                                    icon={pdfIcon}
                                    iconLabel="pdf icon"
                                    className="icon-story-custom-icon actions-icon"
                                    onClick={() =>
                                        handlePdfIconClick(row.original)
                                    }
                                />
                            </Tooltip>
                            <Tooltip content="View Analysis">
                                <GraphUp
                                    className="payout-icon"
                                    size={15}
                                    onClick={() =>
                                        handleAnalysisIconClick(
                                            row.original.payoutId,
                                            row.original.runId,
                                            row.original.documenT_SYSTEM_NUMBER,
                                            row.original.statementType
                                        )
                                    }
                                />
                            </Tooltip>
                            <Tooltip content="View Receiver List">
                                <CardList
                                    className="list-icon"
                                    size={15}
                                    onClick={() =>
                                        handleViewReceiverListOnClick(row.original.documenT_SYSTEM_NUMBER)
                                    }
                                ></CardList>
                            </Tooltip>
                        </div>
                    )
                },
            },
            {
                size: 80,
                maxSize: 80,
                accessorKey: 'statementDate',
                header: (
                    <>
                        <div title="Statement Date">
                            <div className="fw-bold header-container">
                                Statement
                            </div>
                            <div className="fw-bold header-container">Date</div>
                        </div>
                    </>
                ),
                Cell: ({ cell }) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, 'MM/dd/yyyy')
                    return <>{result}</>
                },
            },
            {
                size: 180,
                maxSize: 180,
                accessorKey: 'runName',
                header: (
                    <>
                        <div title="Run Name">
                            <div className="fw-bold header-container">
                                Run
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                size: 160,
                maxSize: 160,
                accessorKey: 'createdDate',
                header: (
                    <>
                        <div title="Upload Date">
                            <div className="fw-bold header-container">
                                Upload
                            </div>
                            <div className="fw-bold header-container">Date</div>
                        </div>
                    </>
                ),
                Cell: ({ cell }) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString).toLocaleString()
                    return <>{date}</>
                },
            },
            {
                size: 80,
                maxSize: 80,
                header: (
                    <>
                        <div title="Reporting Month">
                            <div className="fw-bold header-container">
                                Reporting
                            </div>
                            <div className="fw-bold header-container">
                                Month
                            </div>
                        </div>
                    </>
                ),
                accessorKey: 'reportingMonth',
                Cell: ({ cell }) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, 'MM/dd/yyyy')
                    return <>{result}</>
                },
            },
            {
                size: 100,
                maxSize: 100,
                accessorKey: 'payoutId',
                header: (
                    <>
                        <div title="Payout ID">
                            <div className="fw-bold header-container">
                                Payout
                            </div>
                            <div className="fw-bold header-container">ID</div>
                        </div>
                    </>
                ),
            },
            {
                size: 280,
                maxSize: 280,
                accessorKey: 'payoutName',
                header: (
                    <>
                        <div title="Payout Name">
                            <div className="fw-bold header-container">
                                Payout
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                size: 100,
                maxSize: 100,
                accessorKey: 'statementType',
                header: (
                    <>
                        <div title="Statement Type">
                            <div className="fw-bold header-container">
                                Statement
                            </div>
                            <div className="fw-bold header-container">Type</div>
                        </div>
                    </>
                ),
            },
            {
                size: 100,
                maxSize: 100,
                accessorKey: 'status',
                header: (
                    <>
                        <div title="Statement Status">
                            <div className="fw-bold header-container">
                                Statement
                            </div>
                            <div className="fw-bold header-container">
                                Status
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 110,
                maxSize: 160,
                accessorKey: 'propertyNumber',
                header: (
                    <>
                        <div title="Property Number">
                            <div className="fw-bold header-container">
                                Property
                            </div>
                            <div className="fw-bold header-container">
                                Number
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 210,
                maxSize: 260,
                accessorKey: 'propertyName',
                header: (
                    <>
                        <div title="Property Name">
                            <div className="fw-bold header-container">
                                Property
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'statementEndingBalance',
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                header: (
                    <>
                        <div title="Payout Balance">
                            <div className="fw-bold header-container">
                                Payout
                            </div>
                            <div className="fw-bold header-container">
                                Balance
                            </div>
                        </div>
                    </>
                ),
            },
        ],
        []
    )

    const receiverColumns = useMemo(
        () => [
            {
                header: '',
                size:2,
                maxSize: 2,
                enableSorting: false,
                accessorKey: 'hasDownloadedFile',
                Cell: ({row}) => {
                    return !row.original.hasDownloadedFile ? (
                        <div className='d-flex align-items-center'>
                            <Tooltip content='Unread'>
                                <CircleFill
                                    className='payout-icon'
                                    size={5}
                                />
                            </Tooltip>
                        </div>
                    ) : null
                }
            },
            {
                header: 'Actions',
                size: 60,
                maxSize: 60,
                enableSorting: false,
                Cell: ({ row }) => {
                    return (
                        <div className="d-flex align-items-center">
                            <Tooltip content="Download PDF">
                                <Icon
                                    iconSize={24}
                                    iconType={Icon.type.SRC}
                                    icon={pdfIcon}
                                    iconLabel="pdf icon"
                                    className="icon-story-custom-icon actions-icon"
                                    onClick={() =>
                                        handlePdfIconClick(row.original)
                                    }
                                />
                            </Tooltip>
                            {
                                hasAnalysisReportAccess && (
                                    <Tooltip content="View Analysis">
                                        <GraphUp
                                            className="payout-icon"
                                            size={15}
                                            onClick={() =>
                                                handleAnalysisIconClick(
                                                    row.original.payoutId,
                                                    row.original.runId,
                                                    row.original.documenT_SYSTEM_NUMBER,
                                                    row.original.statementType
                                                )
                                            }
                                        />
                                    </Tooltip>
                                ) 
                            }
                        </div>
                    )
                },
            },
            {
                size: 80,
                maxSize: 80,
                accessorKey: 'statementDate',
                header: (
                    <>
                        <div title="Statement Date">
                            <div className="fw-bold header-container">
                                Statement
                            </div>
                            <div className="fw-bold header-container">Date</div>
                        </div>
                    </>
                ),
                Cell: ({ cell }) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, 'MM/dd/yyyy')
                    return <>{result}</>
                },
            },
            {
                size: 80,
                maxSize: 80,
                accessorKey: 'createdDate',
                header: (
                    <>
                        <div title="Upload Date">
                            <div className="fw-bold header-container">
                                Upload
                            </div>
                            <div className="fw-bold header-container">Date</div>
                        </div>
                    </>
                ),
                Cell: ({ cell }) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, 'MM/dd/yyyy')
                    return <>{result}</>
                },
            },
            {
                size: 80,
                maxSize: 80,
                header: (
                    <>
                        <div title="Reporting Month">
                            <div className="fw-bold header-container">
                                Reporting
                            </div>
                            <div className="fw-bold header-container">
                                Month
                            </div>
                        </div>
                    </>
                ),
                accessorKey: 'reportingMonth',
                Cell: ({ cell }) => {
                    const dateString = cell.getValue()
                    const date = new Date(dateString)
                    const result = format(date, 'MM/dd/yyyy')
                    return <>{result}</>
                },
            },
            {
                size: 100,
                maxSize: 100,
                accessorKey: 'senderName',
                header: (
                    <>
                        <div title="Sender Name">
                            <div className="fw-bold header-container">
                                Sender
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                size: 100,
                maxSize: 100,
                accessorKey: 'payoutId',
                header: (
                    <>
                        <div title="Payout ID">
                            <div className="fw-bold header-container">
                                Payout
                            </div>
                            <div className="fw-bold header-container">ID</div>
                        </div>
                    </>
                ),
            },
            {
                size: 220,
                maxSize: 280,
                accessorKey: 'payoutName',
                header: (
                    <>
                        <div title="Payout Name">
                            <div className="fw-bold header-container">
                                Payout
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                size: 100,
                maxSize: 100,
                accessorKey: 'statementType',
                header: (
                    <>
                        <div title="Statement Type">
                            <div className="fw-bold header-container">
                                Statement
                            </div>
                            <div className="fw-bold header-container">Type</div>
                        </div>
                    </>
                ),
            },
            {
                size: 100,
                maxSize: 100,
                accessorKey: 'status',
                header: (
                    <>
                        <div title="Statement Status">
                            <div className="fw-bold header-container">
                                Statement
                            </div>
                            <div className="fw-bold header-container">
                                Status
                            </div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'propertyNumber',
                size: 100,
                maxSize: 100,
                header: (
                    <>
                        <div title="Property Number">
                            <div className="fw-bold header-container">
                                Property
                            </div>
                            <div className="fw-bold header-container">
                                Number
                            </div>
                        </div>
                    </>
                ),
            },
            {
                size: 200,
                maxSize: 200,
                accessorKey: 'propertyName',
                header: (
                    <>
                        <div title="Property Name">
                            <div className="fw-bold header-container">
                                Property
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                size: 100,
                maxSize: 100,
                accessorKey: 'ownerName1',
                header: (
                    <>
                        <div title="Owner Name">
                            <div className="fw-bold header-container">
                                Owner
                            </div>
                            <div className="fw-bold header-container">Name</div>
                        </div>
                    </>
                ),
            },
            {
                accessorKey: 'statementEndingBalance',
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                header: (
                    <>
                        <div title="Payout Balance">
                            <div className="fw-bold header-container">
                                Payout
                            </div>
                            <div className="fw-bold header-container">
                                Balance
                            </div>
                        </div>
                    </>
                ),
            },
        ],
        [hasAnalysisReportAccess]
    )

    const pageLoad = (isRefetch) => {
        const payoutAdvancedSearch = getAdvancedSearchValues()
        
        if (payoutAdvancedSearch.senderNumber){
            requestAvailableRuns(payoutAdvancedSearch.senderNumber, DocumentTypes.PAYOUT_STATEMENT)
        }

        if (stateData){
            setRunNames(stateData.runData)
            
            setShowAdvancedSearch(true)

            setSelectedReportingMonthDates([null, null])
            payoutAdvancedSearch.reportingMonthFrom = null
            payoutAdvancedSearch.reportingMonthTo = null
        }        

        GetPayoutAllStatementsPaginated(payoutAdvancedSearch, isRefetch)
    }

    const partialPageLoad = () => {
        if (type === Usertype.RECEIVER) {
            pageLoad(true)
        }
    }

    useEffect(() =>{   
        pageLoad()     
        window.addEventListener('PdfDownloadComplete', partialPageLoad)

        return () => window.removeEventListener('PdfDownloadComplete', partialPageLoad)
    }, [])

    useEffect(() => {
        if (isMounted.current) {
            const payoutAdvancedSearch = getAdvancedSearchValues()
            GetPayoutAllStatementsPaginated(payoutAdvancedSearch)
        }
    }, [pagination.pageIndex, pagination.pageSize])

    useEffect(() => {
        if (isMounted.current) {
            const payoutAdvancedSearch = getAdvancedSearchValues()
            GetPayoutAllStatementsPaginated(payoutAdvancedSearch)
        }
    }, [sorting])

    useEffect(() => {
        if (isMounted.current) {
            setColumnVisibility(columnVisibility) //programmatically show firstName column
        }
    }, [columnVisibility])

    useEffect(() => {
        if (isMounted.current) {
            if (pagination.pageIndex === 0) {
                const payoutAdvancedSearch = getAdvancedSearchValues()
                GetPayoutAllStatementsPaginated(payoutAdvancedSearch)
            } else {
                setPagination({ pageIndex: 0, pageSize: pagination.pageSize })
            }
        }
    }, [selectedStatus, selectedStatementType])

    const GetPayoutAllStatementsPaginated = (payoutAdvancedSearch, isRefetch) => {
        var data = payoutAdvancedSearch
        var url = ''
        if (type === Usertype.SENDER) {
            url = '/GetSenderPayoutAllStatementsPaginated'
        }
        if (type === Usertype.RECEIVER) {
            url = '/GetReceiverPayoutAllStatementsPaginated'
        }

        if (!tableData.length || !isRefetch)
            setIsLoading(true)
        else
            setIsFetching(true)
        axios
            .post(url, data)
            .then((response) => {
                setTableData(response.data.items)
                setRowCount(response.data.totalCount)
                if (response.data.hasPDFMassDownload != null) {
                    setHasMassDownload(response.data.hasPDFMassDownload)
                }
                isMounted.current = true
            })
            .catch(() => {
                setIsLoading(false)
                setIsFetching(false)
            })
            .finally(() => {
                setIsLoading(false)
                setIsFetching(false)
            })
    }

    const showDownloadToast = (fileType) => {
        toast.success(`Downloading ${fileType}`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--success-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
        })
    }

    const handlePdfIconClick = (row) => {
        showDownloadToast('PDF')
        const { documenT_SYSTEM_NUMBER, runId, ownerName1 } = row
        const postData = []
        const data = {
            documentSystemNumber: documenT_SYSTEM_NUMBER,
            ownerName: ownerName1,
            runId,
        }
        postData.push(data)

        if (postData.length) {
            getPayoutStatementPDF(postData, type)
        }
    }

    const handleSearchChange = (value) => {
        setSearchInput(value.trim())
    }

    const getAdvancedSearchValues = () => {
        const searchParamsObj = Object.fromEntries([...searchParams])
        const { senderNumber } = searchParamsObj

        const payoutAdvancedSearch = {
            payoutId,
            payoutName,
            propertyName,
            propertyNumber,
            senderName,
            ownerNumber,
            ownerName,
            globalSearch: searchInput,
            status: selectedStatus?.value,
            statementType: selectedStatementType?.value,
            reportingMonthFrom: selectedReportingMonthDates?.[0] ? selectedReportingMonthDates?.[0] : null,
            statementDateFrom: selectedStatementDates?.[0] ?  selectedStatementDates?.[0] : null,
            statementDateTo: selectedStatementDates?.[1] ? selectedStatementDates?.[1] : null,
            reportingMonthTo: selectedReportingMonthDates?.[1] ? selectedReportingMonthDates?.[1] : null,
            filterByUnreadDocument: isUnreadFiltered.current,
            senderNumber: type === Usertype.SENDER ? senderNumber : '',
            pageNumber: pagination.pageIndex + 1,
            pageSize: pagination.pageSize,
            sortDesc: sorting[0]?.desc,
            SortBy: sorting[0]?.id,
            runNames: stateData ? stateData.runData : null
        }

        return payoutAdvancedSearch
    }

    const handleSearchSubmit = () => {
        setPagination({ pageIndex: 0, pageSize: pagination.pageSize })
        const payoutAdvancedSearch = getAdvancedSearchValues()
        GetPayoutAllStatementsPaginated(payoutAdvancedSearch)
    }

    const cleanAdvancedSearchInputs = () => {
        setPayoutId('')
        setPayoutName('')
        setPropertyName('')
        setPropertyNumber('')
        setSenderName('')
        setOwnerName('')
        setOwnerNumber('')
        setRunNames([])
    }

    const handleAnalysisIconClick = (
        payoutId,
        runId,
        documentNumber,
        statementType
    ) => {
        const searchParamsObj = Object.fromEntries([...searchParams])
        const { senderNumber } = searchParamsObj

        setAnalysisPayoutFilters({
            senderNumber: senderNumber,
            runId: runId,
            documentNumber: documentNumber,
            statementType: statementType,
            pageNumber: 1,
            pageSize: 25,
        })
    }

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const handleViewReceiverListOnClick = (documentSystemNumber) => {
        setDocSysNumber(documentSystemNumber)
        handleOpenModal()
    }

    const onDownloadButtonClicked = (rows, selectedRadio) => {
        const selectedRows = Object.keys(rows)
        const postData = selectedRows.map(row => {
            const splittedKey = getRowSelectionBaseKey(row).split(',')
            return {
                documentSystemNumber: splittedKey[0],
                runId: splittedKey[1],
                ownerName: splittedKey[2] ?? ''
            }
        })
        showDownloadToast('PDF')
        getPayoutStatementPDF(postData, type)
    }

    return (
        <>
            <Row>
                <PayoutAllStatementsForm
                    showAdvancedSearch={showAdvancedSearch}
                    setShowAdvancedSearch={setShowAdvancedSearch}
                    setSelectedStatementDates={setSelectedStatementDates}
                    handleSearchSubmit={handleSearchSubmit}
                    setSelectedStatus={setSelectedStatus}
                    handleSearchChange={handleSearchChange}
                    cleanAdvancedSearchInputs={cleanAdvancedSearchInputs}
                    setSelectedStatementType={setSelectedStatementType}
                    type={type}
                    isUnreadFiltered={isUnreadFiltered}
                    onTabChange={partialPageLoad}
                    statementDateFrom={(selectedStatementDates?.[0] === null ? null : new Date(selectedStatementDates?.[0]))}
                    statementDateTo={(selectedStatementDates?.[1] === null ? null : new Date(selectedStatementDates?.[1]))}
                />
            </Row>
            {showAdvancedSearch && (
                <Row>
                    <PayoutAllStatementAdvanceSearchForm
                        setSelectedReportingMonthDates={setSelectedReportingMonthDates}
                        setSenderName={setSenderName}
                        setPropertyNumber={setPropertyNumber}
                        setPayoutId={setPayoutId}
                        setPropertyName={setPropertyName}
                        setPayoutName={setPayoutName}
                        setOwnerName={setOwnerName}
                        setOwnerNumber={setOwnerNumber}
                        type={type}
                        runNameOptions={runNameOptions}
                        setRunNames={setRunNames}
                        runNames = {runNames}
                        reportingMonthFrom={(selectedReportingMonthDates?.[0] === null ? null : new Date(selectedReportingMonthDates?.[0]))}
                        reportingMonthTo={(selectedReportingMonthDates?.[1] === null ? null : new Date(selectedReportingMonthDates?.[1]))}
                    />
                </Row>
            )}
            <Row>
                {/*We might want to move this up, for now we will leave it on the table*/}
                <section className="statements-container mb-5">
                    <div className="table-wrapper">
                        <TableReport
                            enableManualSorting={true}
                            setColumnVisibility={setColumnVisibility}
                            onPaginationChange={setPagination}
                            pagination={pagination}
                            sorting={sorting}
                            onSortingChange={setSorting}
                            enableRowSelection={true}
                            hasMassDownload={hasMassDownload}
                            enableHide={type === Usertype.SENDER && !IS_USER}
                            rowCount={rowCount}
                            columnVisibility={columnVisibility}
                            columns={
                                type === Usertype.SENDER
                                    ? senderColumns
                                    : receiverColumns
                            }
                            tableData={tableData}
                            onDownloadButtonClicked={
                                onDownloadButtonClicked
                            }
                            rowId={(row) => { 
                                if(tableData.length > 0)
                                    return (row.documenT_SYSTEM_NUMBER ?? '') + ',' + (row.runId ?? '') + ',' + (row.ownerName1 ?? '') + ',' + (row.status ?? '') + ',' + (row.hasDownloadFile)
                            }}
                            setRowSelection={setRowSelection}
                            rowSelection={rowSelection}
                            isLoading={isLoading}
                            isFetching={isFetching}
                            isPayout={true}
                        />
                    </div>
                </section>
            </Row>
            {openModal && (
                <ReceiverList
                    type={type}
                    open={openModal}
                    onClose={handleCloseModal}
                    documentSystemNumber={docSysNumber}
                    statementType="PO"
                    hasMassDownload={hasMassDownload}
                />
            )}
        </>
    )
}

export default PayoutAllStatements
